import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userSlices from "./slices/userSlices";

const rootPersistConfig = {
  key: "uob-pg",
  storage: storage,
  blacklist: ["error_send_data"],
};

const rootReducer = combineReducers({
  user: persistReducer(rootPersistConfig, userSlices),
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);
